import { JobState } from 'ducks/job/slices';
import { normalizeTimeout } from 'utils/normalizers';
import { v4 as uuidv4 } from 'uuid';

export const normalizeJobParameters = (state: JobState) => {
  return [
    { label: 'CPU', value: state.cpu || 0, uuid: uuidv4() },
    { label: 'Memory', value: `${state.memory_gb}GB` || 0, uuid: uuidv4() },
    { label: 'GPU', value: state.gpu || 0, uuid: uuidv4() },
    { label: 'Shared Memory', value: `${state.shared_memory_mb}MB` || 0, uuid: uuidv4() },
    { label: 'Storage', value: `${state.storage_gb}GB` || 0, uuid: uuidv4() },
    { label: 'CPU Architecture', value: state.cpu_architecture_name, uuid: uuidv4() },
    {
      label: 'Timeout',
      value: state.timeout_seconds && normalizeTimeout(state.timeout_seconds),
      uuid: uuidv4(),
    },
    { label: 'Max Retries', value: state.max_retries, uuid: uuidv4() },
    { label: 'Prevent Preemption', value: state.prevent_preemption_name, uuid: uuidv4() },
    { label: 'Location Group', value: state.location_group_name, uuid: uuidv4() },
    {
      label: 'Results Method',
      value:
        state.result_method_id === 2
          ? `${state.result_method_name}(${state.stdout_success_text})`
          : state.result_method_name,
      uuid: uuidv4(),
    },
  ];
};
